var module = angular.module('octopusApp.projects');

module.directive('azureResourceGroupParameters', function(octopusRepository){
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/projects/actions/azure_resource_group/azure_resource_group_parameters.html',
    scope: {
      project: '=',
      action: '='
    },
    link: function ($scope) {
      $scope.parameterValues = {};
      $scope.parameters = {};
      $scope.source = { octopus: "octopus", azureKeyVault: "azureKeyVault"};

      var armJsonParamTypes = ["array", "object", "secureObject"];

      function populateValuesWithTemplateParameters(parameters) {
        removeOrphanParameterValues(parameters);
        addMissingParameterValues(parameters);
        provideDefaults(parameters);
      }

      function populateValuesWithTemplateParameterValues(armParameters, parameters) {
        _.each(armParameters, function(parameter, parameterName) {
          var parameterValue = {};

          if (parameter.reference) {
            parameterValue.keyVaultId = parameter.reference.keyVault.id;
            parameterValue.keyVaultSecretName = parameter.reference.secretName;
            parameterValue.source = $scope.source.azureKeyVault;
          } else {
            setParameterValue(parameterValue, parameter.value);
            parameterValue.source = $scope.source.octopus;
          }

          $scope.parameterValues[parameterName] = parameterValue;
        });

        provideDefaults(parameters);
    }

      function removeOrphanParameterValues(parameters){
        _.each($scope.parameterValues, function(value, key){
          if (parameters[key] === undefined) {
            delete $scope.parameterValues[key];
          }
        });
      }

      function addMissingParameterValues(parameters){
        _.each(parameters, function(value, parameterName) {
          if ($scope.parameterValues[parameterName] === undefined) {
            $scope.parameterValues[parameterName] = {};
          }
        });
      }

      function provideDefaults(parameters){
        _.each(parameters, function(value, parameterName) {
          var parameterValue =  $scope.parameterValues[parameterName];

          if (parameterValue.value === undefined && value.defaultValue !== undefined) {
            setParameterValue(parameterValue, value.defaultValue);
          }

          if (parameterValue.source === undefined) {
            parameterValue.source = $scope.source.octopus;
          }

          if (parameterValue.type === undefined) {
            parameterValue.type = normalizeType(value.type);
          }

          if (parameterValue.description === undefined && value.metadata !== undefined) {
            parameterValue.description = value.metadata.description;
          }

          if (parameterValue.allowedValues === undefined) {
            parameterValue.allowedValues = value.allowedValues;
          }
        });
      }

      function setParameterValue(parameterValue, value) {
        if (_.isObject(value)) {
          parameterValue.value = JSON.stringify(value, undefined, 4);
        } else {
          parameterValue.value = value;
        }
      }

      //Technically speaking type names should follow camelCase naming convention as per https://azure.microsoft.com/en-us/documentation/articles/resource-group-authoring-templates/
      //but even Visual Studio project does not follow it.
      function normalizeType(type){
        return type.toLowerCase();
      }

      //Parameters that are of type 'array', 'object' or 'secureObject' needs to be parsed as JSON,
      //otherwise the template will not be deemed valid as they will be used as a string and the deployment
      //will fail with an error message similar to the below:
      //'Hyak.Common.CloudException: InvalidTemplate: Deployment template validation failed: 
      //'The provided value for the template parameter '<parameterName>' at line 'x' and column 'y' is not valid.'. 
      function shouldJsonParse(type) {
        return armJsonParamTypes.indexOf(type) >= 0;
      }

      $scope.$watch("action.Properties['Octopus.Action.Azure.ResourceGroupTemplateParameters']",
        function(newVal){
          if (!newVal) {
            return;
          }

          try {
            var armParameters = angular.fromJson(newVal);
            populateValuesWithTemplateParameterValues(armParameters, $scope.parameters);
          } catch(e){
            $scope.parameterValues = {};
          }
        });

      $scope.$watch("action.Properties['Octopus.Action.Azure.ResourceGroupTemplate']",
        function(newVal){
          if (newVal) {
            try {
              var template = angular.fromJson(newVal);
              if (template.parameters) {
                $scope.parameters = template.parameters;
              } else{
                $scope.parameters = {};
              }
            } catch (e){}
          } else {
            $scope.parameters = {};
          }
          populateValuesWithTemplateParameters($scope.parameters);
        }
      );

      // whenever parameter values are modified, serialize back into JSON parameter format, and save onto action
      $scope.$watch("parameterValues",
          function(parameterValues){
            if (parameterValues) {
              var armParams = {};
              _.each(parameterValues, function(paramValue, paramName){

                var armParameterValue = {};
                if (paramValue.source !== $scope.source.azureKeyVault) {
                  if (shouldJsonParse(paramValue.type)) {
                    armParameterValue.value = JSON.parse(paramValue.value);
                  } else {
                    armParameterValue.value = paramValue.value;
                  }
                } else {
                  armParameterValue.reference = {
                    keyVault: {
                      id: paramValue.keyVaultId
                    },
                    secretName: paramValue.keyVaultSecretName
                  };
                }

                armParams[paramName] = armParameterValue;
              });
              $scope.action.Properties['Octopus.Action.Azure.ResourceGroupTemplateParameters'] = angular.toJson(armParams);
            }
          }, true);
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_resource_group/azure_resource_group_parameters.js
// module id = 490
// module chunks = 1